__webpack_require__.p = "/lp/vendor-management-software/";